import './Logout.css';
import { Context } from '../Context';
import { useContext, useEffect } from 'react';


const Logout = () => {
    const contextObject = useContext(Context);

    // Handle keyboard events for accessibility
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                contextObject.goHome();
            } else if (event.key === 'Enter') {
                contextObject.logoutUser();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [contextObject]);

    // Handle backdrop click to close modal
    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            contextObject.goHome();
        }
    };

    return (
        <div className='Logout-Window' onClick={handleBackdropClick}>
            <div className='Logout-Frame' role="dialog" aria-labelledby="logout-title" aria-modal="true">
                <h2 id="logout-title" className='Logout-Title'>
                    Are you sure you want to log out?
                </h2>
                <div className='Logout-Button-Group'>
                    <button 
                        className='Logout-Button-Confirm' 
                        onClick={() => contextObject.logoutUser()}
                        autoFocus
                        aria-label="Confirm logout"
                    >
                        Logout
                    </button>
                    <button 
                        className='Logout-Button-Cancel' 
                        onClick={() => contextObject.goHome()}
                        aria-label="Cancel logout"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
};

export default Logout;